module.exports = __webpack_public_path__ + "find.746752642a4dcccc37cb.png";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/images/find.png
// module id = ../../../../../src/assets/images/find.png
// module chunks = 2